import { createSlice } from '@reduxjs/toolkit';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';

export const aoiSlice = createSlice({
    name: 'aoi',
    initialState: {
        source: new VectorSource({ wrapX: false })
    },
    reducers: {
        setFeature: (state, action) => {
            state.source.clear();
            const feature = action?.payload;
            if (feature && feature instanceof Feature) {
                state.source.addFeature(feature.clone());
            }
        }
    }
});

// Action creators are generated for each case reducer function
export const { setFeature } = aoiSlice.actions;

export default aoiSlice.reducer;
